import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface ApiResponse<T> {
	status: boolean;
	data: T;
	message?: string;
}

export interface DashboardStats {
	total_appointments: number;
	pending_appointments: number;
	confirmed_appointments: number;
	completed_appointments: number;
	cancelled_appointments: number;
	total_customers: number;
	new_customers_this_month: number;
	active_services: number;
	appointments_this_month: number;
	appointments_last_month: number;
	customers_this_month: number;
	customers_last_month: number;
	today_count?: number;
	today_pending?: number;
	today_confirmed?: number;
	today_completed?: number;
	upcoming?: number;
	this_week?: number;
}

export interface RecentAppointment {
	id: number;
	customer: {
		id: number;
		first_name: string;
		last_name: string;
		phone: string;
		email: string | null;
	};
	service: {
		id: number;
		service_name: string;
	};
	appointment_date: string;
	start_time: string;
	end_time: string;
	status: 'pending' | 'confirmed' | 'completed' | 'cancelled';
	notes: string | null;
}

@Injectable({
	providedIn: 'root',
})
export class AdminService {
	private http = inject(HttpClient);
	private apiUrl = environment.apiUrl;

	// Dashboard Stats
	getAppointmentStats(): Observable<ApiResponse<DashboardStats>> {
		return this.http.get<ApiResponse<DashboardStats>>(`${this.apiUrl}/admin/appointments/stats`);
	}

	// Recent Appointments
	getAppointments(params?: { limit?: number; status?: string }): Observable<ApiResponse<{ data: RecentAppointment[] }>> {
		return this.http.get<ApiResponse<{ data: RecentAppointment[] }>>(`${this.apiUrl}/admin/appointments`, { params });
	}

	// Get trend data for charts
	getTrendData(period: string): Observable<ApiResponse<{ label: string; value: number }[]>> {
		return this.http.get<ApiResponse<{ label: string; value: number }[]>>(`${this.apiUrl}/admin/appointments/trend`, { 
			params: { period } 
		});
	}
}
